var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pt-30 pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "140px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      ref: "code_tag",
                      attrs: { label: "设备类型：", prop: "code_tag" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择设备类型" },
                          on: { change: _vm.deviceChange },
                          model: {
                            value: _vm.form.code_tag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "code_tag", $$v)
                            },
                            expression: "form.code_tag",
                          },
                        },
                        [
                          _vm._l(_vm.deviceList, function (item) {
                            return [
                              _c("el-option", {
                                attrs: {
                                  label: item.type_name,
                                  value: item.code_tag,
                                },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { ref: "num", attrs: { label: "生成数量：", prop: "num" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "生成二维码的数量" },
                        model: {
                          value: _vm.form.num,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "num", $$v)
                          },
                          expression: "form.num",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "factory_id",
                      attrs: { label: "设备工厂：", prop: "factory_id" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择设备工厂" },
                          model: {
                            value: _vm.form.factory_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "factory_id", $$v)
                            },
                            expression: "form.factory_id",
                          },
                        },
                        [
                          _vm._l(_vm.factoryList, function (item) {
                            return [
                              item.support_device_type &&
                              item.support_device_type.indexOf(
                                _vm.sel_depend_type + ","
                              ) > -1
                                ? _c("el-option", {
                                    attrs: {
                                      label: item.factory_name,
                                      value: item.factory_id,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.factory_id == "Shark"
                    ? _c(
                        "el-form-item",
                        {
                          ref: "num",
                          attrs: { label: "仓口数量：", prop: "num" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "设备仓口数量" },
                            model: {
                              value: _vm.form.bayonet,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bayonet", $$v)
                              },
                              expression: "form.bayonet",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "生成二维码图片：" } },
                    [
                      _c("el-checkbox", {
                        attrs: { "true-label": 1, "false-label": 0 },
                        model: {
                          value: _vm.form.open,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "open", $$v)
                          },
                          expression: "form.open",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s3 text-gray" }, [
                        _vm._v(
                          "注：勾选时，由于生成二维码图片较慢，建议每次生成数量不要超过100，适合需要下载二维码图片的设备类型。不勾选时，建议数量不要超过5000。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.form.open == 1,
                          expression: "form.open == 1",
                        },
                      ],
                      attrs: { label: "logo：" },
                    },
                    [
                      _c("upload", {
                        model: {
                          value: _vm.form.logo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "logo", $$v)
                          },
                          expression: "form.logo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("生成")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }